<template>
  <div class="account-page register-page register-detail-page">
    <!-- bg -->
    <div class="bg" ref="videoBg" v-if="!isMobile">
      <img :src="poster" alt="" />
      <div class="mask"></div>
    </div>
    <!-- header -->
    <div class="header">
      <el-button
        type="primary"
        size="small"
        @click="goIndex"
        v-text="'< 返回首页'"
      ></el-button>
    </div>
    <!-- form wrapper -->
    <div class="form-wrapper">
      <h1 class="form-header">
        <p class="main-title">{{ pageTitle }}</p>
        <!--<p class="main-title">注册 ·  企业</p>-->
        <div class="operate">
          <el-button type="text" @click="goLogin">前往登录</el-button>
          <!--<el-button type="text" @click="goback">重选类型</el-button>-->
        </div>
      </h1>

      <!-- form -->
      <el-form
        ref="form"
        class="form"
        :model="form"
        :rules="rules"
        label-position="top"
      >
        <!--errors:{{ errors }}-->
        <el-row :gutter="20">
          <el-col :span="span">
            <el-form-item
              label="企业全称"
              prop="companyName"
              :error="errors.companyName"
            >
              <el-input
                v-model="form.companyName"
                suffix-icon="el-icon-office-building"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="span">
            <el-form-item
              label="社会信用代码号"
              prop="socialCreditNo"
              :error="errors.socialCreditNo"
            >
              <el-input
                v-model="form.socialCreditNo"
                suffix-icon="el-icon-connection"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="span">
            <el-form-item label="Email" prop="email" :error="errors.email">
              <el-input
                v-model="form.email"
                suffix-icon="el-icon-message"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="span">
            <el-form-item
              label="通信地址"
              prop="address"
              :error="errors.address"
            >
              <el-input
                v-model="form.address"
                suffix-icon="el-icon-location-information"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="span">
            <el-form-item
              label="法人名称"
              prop="legalPersonName"
              :error="errors.legalPersonName"
            >
              <el-input
                v-model="form.legalPersonName"
                suffix-icon="el-icon-user"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="span">
            <el-form-item
              label="法人手机"
              prop="legalPersonMobile"
              :error="errors.legalPersonMobile"
            >
              <el-input
                v-model="form.legalPersonMobile"
                suffix-icon="el-icon-phone-outline"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="span">
            <el-form-item
              label="法人身份证号"
              prop="legalPersonCertNo"
              :error="errors.legalPersonCertNo"
            >
              <el-input
                v-model="form.legalPersonCertNo"
                suffix-icon="el-icon-c-scale-to-original"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="span">
            <el-form-item
              label="授权人姓名"
              prop="authPersonName"
              :error="errors.authPersonName"
            >
              <el-input
                v-model="form.authPersonName"
                suffix-icon="el-icon-user"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="span">
            <el-form-item
              label="授权人身份证号"
              prop="authPersonCertNo"
              :error="errors.authPersonCertNo"
            >
              <el-input
                v-model="form.authPersonCertNo"
                suffix-icon="el-icon-c-scale-to-original"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="span">
            <el-form-item
              label="授权人银行类型"
              prop="bankcode"
              :error="errors.bankcode"
            >
              <el-select
                v-model="form.bankcode"
                filterable
                remote
                reserve-keyword
                placeholder="检索银行名称"
                :remote-method="remoteMethod"
                :loading="selectLoading"
                @focus="remoteMethod('')"
              >
                <el-option
                  v-for="item in enums.bankType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="span">
            <el-form-item
              label="授权人银行卡号"
              prop="authPersonBankNo"
              :error="errors.authPersonBankNo"
            >
              <el-input
                v-model="form.authPersonBankNo"
                suffix-icon="el-icon-bank-card"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="span">
            <el-form-item
              label="授权人手机号"
              prop="authPersonMobile"
              :error="errors.authPersonMobile"
            >
              <el-input
                v-model="form.authPersonMobile"
                suffix-icon="el-icon-phone-outline"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="span">
            <el-form-item
              label="营销码"
              prop="marketingCode"
              :error="errors.marketingCode"
            >
              <el-input
                v-model="form.marketingCode"
                suffix-icon="el-icon-film"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 附件 -->
        <el-row :gutter="20">
          <!-- 三证合一扫描件 -->
          <el-col :span="span">
            <el-form-item
              label=""
              prop="socialCreditPic"
              :error="errors.socialCreditPic"
            >
              <div slot="label" class="custom-label">
                <p class="text">
                  <span class="require-icon">*</span>三证合一扫描件
                  <el-tooltip
                    placement="top"
                    v-if="form.socialCreditPic !== null"
                  >
                    <div slot="content">
                      {{ form.socialCreditPic.name }}
                    </div>
                    <i class="icon el-icon-success"></i>
                  </el-tooltip>
                </p>
                <el-tooltip placement="top">
                  <div slot="content">
                    <img
                      :src="`${baseUrl}file/sample_lisence.jpg`"
                      alt="三证合一扫描件"
                      style="width: 300px;"
                    />
                  </div>
                  <el-button type="text" size="small">查看示例</el-button>
                </el-tooltip>
              </div>
              <el-upload
                class="upload"
                action
                :before-upload="beforeUploadSocialCreditPic"
              >
                <el-button size="small" type="primary" :loading="fileLoading.socialCreditPic">上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  <span v-if="form.socialCreditPic !== null && form.socialCreditPic.name">{{ form.socialCreditPic.name }}</span>
                  <span v-else>支持JPG、PNG格式，不超过2M</span>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
          <!-- 君子签申请表 -->
          <el-col :span="span">
            <el-form-item
              label=""
              prop="contractImg"
              :error="errors.contractImg"
            >
              <div slot="label" class="custom-label">
                <p class="text">
                  <span class="require-icon">*</span>君子签申请表
                  <el-tooltip placement="top" v-if="form.contractImg !== null">
                    <div slot="content">
                      {{ form.contractImg.name }}
                    </div>
                    <i class="icon el-icon-success"></i>
                  </el-tooltip>
                </p>
                <div>
                  <a
                    class="download-link"
                    :href="contractImgFileUrl"
                    download="企业签约服务授权书.doc"
                  >
                    模板下载
                  </a>
                  <el-tooltip placement="top">
                    <div slot="content">
                      <img
                        :src="`${baseUrl}/file/tonghua_apply.jpg`"
                        alt="君子签申请表"
                        style="width: 300px;"
                      />
                    </div>
                    <el-button type="text" size="small">查看示例</el-button>
                  </el-tooltip>
                </div>
              </div>
              <el-upload
                class="upload"
                action
                :before-upload="beforeUploadContractImg"
              >
                <el-button size="small" type="primary" :loading="fileLoading.contractImg">上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  <span v-if="form.contractImg !== null && form.contractImg.name">{{ form.contractImg.name }}</span>
                  <span v-else>支持JPG、PNG格式，不超过2M</span>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
          <!-- 签章图片 -->
          <el-col :span="span">
            <el-form-item label="" prop="signPic" :error="errors.signPic">
              <div slot="label" class="custom-label">
                <p class="text">
                  <span class="require-icon">*</span>签章图片
                  <el-tooltip placement="top" v-if="form.signPic !== null">
                    <div slot="content">
                      {{ form.signPic.name }}
                    </div>
                    <i class="icon el-icon-success"></i>
                  </el-tooltip>
                </p>
                <div>
                  <a
                    class="download-link"
                    href="http://www.aigei.com/bgremover"
                    target="_blank"
                  >
                    透明处理链接
                  </a>
                  <el-tooltip placement="top">
                    <div slot="content">
                      <img
                        :src="`${baseUrl}/file/sample_seal.png`"
                        alt="签章图片"
                        style="width: 240px;"
                      />
                    </div>
                    <el-button type="text" size="small">查看示例</el-button>
                  </el-tooltip>
                </div>
              </div>
              <el-upload
                class="upload"
                action
                :before-upload="beforeUploadSignPic"
              >
                <el-button size="small" type="primary" :loading="fileLoading.signPic">上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  <span v-if="form.signPic !== null && form.signPic.name">{{ form.signPic.name }}</span>
                  <span v-else>透明背景的PNG，178px*178px</span>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 密码 -->
        <el-row :gutter="20">
          <el-col :span="span">
            <el-form-item label="密码" prop="pwd" :error="errors.pwd">
              <el-input
                v-model="form.pwd"
                clearable
                show-password
                placeholder="6至15个字符"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="span">
            <el-form-item
              label="确认密码"
              prop="pwdCopy"
              :error="errors.pwdCopy"
            >
              <el-input
                v-model="form.pwdCopy"
                clearable
                show-password
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 阅读协议 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="" class="no-border no-margin">
              <el-checkbox-group v-model="form.isAgree" class="protocol-form">
                <el-checkbox label="我已阅读并同意"></el-checkbox>
                <el-button class="protocol" type="text" @click="showProtocol">{{
                  protocolName
                }}</el-button>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 提交 -->
        <el-row :gutter="20">
          <el-form-item class="no-border">
            <!-- 远端错误 -->
            <el-alert
              class="error"
              v-if="error"
              type="error"
              :closable="false"
              >{{ error }}</el-alert
            >
            <el-button
              type="primary"
              class="submit-button"
              @click="submit"
              :loading="loading"
              >注册</el-button
            >
          </el-form-item>
        </el-row>
      </el-form>

      <!-- 协议 -->
      <protocol
        ref="protocol"
        @on-update="updateProtocol"
        @on-agree="agreeProtocol"
      ></protocol>
    </div>
  </div>
</template>

<script>
import {
  identifyIdPattern,
  validateFileType,
  validateFileSize
} from "@/libs/formValidate";
import mixin from "./mixins/mixin";
import { OSSUpload } from "@/libs/OSS/index.js";

export default {
  mixins: [mixin],
  data() {
    return {
      enums: {
        bankType: []
      },
      form: {
        registerMode: "1", // 企业模式
        legalPersonName: "",
        authPersonMobile: "",
        legalPersonMobile: "",
        legalPersonCertNo: "",
        authPersonName: "",
        authPersonCertNo: "",
        bankcode: "",
        authPersonBankNo: "",
        companyName: "",
        socialCreditNo: "",
        email: "",
        address: "",
        marketingCode: "",
        socialCreditPic: null,
        contractImg: null,
        signPic: null,
        pwd: "",
        pwdCopy: "",
        // 冗余字段
        isAgree: []
      },
      rules: {
        companyName: [
          { required: true, message: "请输入企业名称", trigger: "change" }
        ],
        socialCreditNo: [
          { required: true, message: "请输入社会信用代码号", trigger: "change" }
        ],
        email: [
          { required: true, message: "请输入邮箱" },
          {
            type: "string",
            pattern: /^\w+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/,
            message: "请输入正确的邮箱地址",
            trigger: "change"
          }
        ],
        address: [{ required: true, message: "请输入地址", trigger: "change" }],
        legalPersonName: [
          { required: true, message: "请输入法人姓名", trigger: "change" }
        ],
        legalPersonMobile: [
          { required: true, message: "请输入手机号码", trigger: "change" }
        ],
        legalPersonCertNo: [
          { required: true, message: "请输入法人身份证号", trigger: "change" },
          {
            pattern: identifyIdPattern(),
            message: "请输入正确的格式",
            trigger: "change"
          }
        ],
        authPersonName: [
          { required: true, message: "请输入授权人姓名", trigger: "change" }
        ],
        authPersonCertNo: [
          { required: true, message: "身份证号不能为空", trigger: "change" },
          { pattern: identifyIdPattern(), message: "请输入正确的格式" }
        ],
        bankcode: [
          { required: true, message: "请选择银行卡类型", trigger: "change" }
        ],
        authPersonBankNo: [
          { required: true, message: "请输入授权人银行卡号", trigger: "change" }
        ],
        authPersonMobile: [
          { required: true, message: "请输入授权人手机号", trigger: "change" }
        ],
        marketingCode: [
          { pattern: /^[0-9]{7}$/, message: "请输入7位数字营销码", trigger: "change" }
        ],
        socialCreditPic: [
          { validator: this.validLFNotNull, trigger: "change" }
        ],
        contractImg: [{ validator: this.validPFNotNull, trigger: "change" }],
        signPic: [{ validator: this.validSFNotNull, trigger: "change" }],
        pwd: [
          { required: true, message: "请输入密码", trigger: "change" },
          {
            type: "string",
            min: 6,
            max: 15,
            message: "请设置6至15个字符的密码",
            trigger: "change"
          }
        ],
        pwdCopy: [
          { required: true, message: "请再次输入密码", trigger: "change" },
          {
            type: "string",
            min: 6,
            max: 15,
            message: "请设置6至15个字符的密码",
            trigger: "change"
          },
          {
            validator: this.validSamePassword,
            message: "请保持密码一致",
            trigger: "change"
          }
        ]
      },
      errors: {
        legalPersonName: "",
        legalPersonMobile: "",
        legalPersonCertNo: "",
        authPersonName: "",
        authPersonCertNo: "",
        bankcode: "",
        authPersonBankNo: "",
        authPersonMobile: "",
        companyName: "",
        socialCreditNo: "",
        email: "",
        address: "",
        marketingCode: "",
        socialCreditPic: "",
        contractImg: "",
        signPic: "",
        pwd: "",
        pwdCopy: ""
      },
      loading: false,
      fileLoading: {
        socialCreditPic: false,
        contractImg: false,
        signPic: false
      },
      selectLoading: false
    };
  },
  computed: {
    // 君子签
    contractImgFileUrl() {
      return `${this.baseUrl}file/企业签约服务授权书.doc`;
    },
    poster() {
      return `${this.baseUrl}media/trade_cover.png`;
    }
  },
  created() {
    // this.test();
  },
  methods: {
    remoteMethod(query = "") {
      const param = {
        bank_name: query,
        page: 1,
        size: 150
      };
      this.selectLoading = true;
      this.$request.enums_getBankCodeType(param).then(res => {
        const { code = -1, listData = [] } = res;

        this.selectLoading = false;
        if (code !== 0) {
          this.enums.bankType = [];
          return;
        }

        this.enums.bankType = ((listData && listData["list"]) || []).map(
          item => ({ label: item.bankname, value: item.bankcode })
        );
      });
    },

    /**
     * 验证业务逻辑
     */

    // 验证三证合一扫描件必填
    validLFNotNull(rule, value, callback) {
      this.form.socialCreditPic
        ? callback()
        : callback(new Error("请上传图片"));
    },

    // 验证君子签必填
    validPFNotNull(rule, value, callback) {
      this.form.contractImg ? callback() : callback(new Error("请上传图片"));
    },

    // 验证签章必填
    validSFNotNull(rule, value, callback) {
      this.form.signPic ? callback() : callback(new Error("请上传图片"));
    },

    // 上传：三证合一扫描件
    beforeUploadSocialCreditPic(file) {
      // 验证格式
      if (!validateFileType(file, ["png", "jpeg", "image/jpeg"])) return false;
      // 验证大小
      if (!validateFileSize(file, "2M")) return false;

      // oss上传
      this.ossUpload("socialCreditPic", file);

      return false;
    },

    // 上传：君子签申请表
    beforeUploadContractImg(file) {
      // 验证格式
      if (!validateFileType(file, ["png", "jpeg", "image/jpeg"])) return false;
      // 验证大小
      if (!validateFileSize(file, "2M")) return false;

      // oss上传
      this.ossUpload("contractImg", file);

      return false;
    },

    // 上传：签章
    beforeUploadSignPic(file) {
      // 验证格式
      if (!validateFileType(file, ["image/png", "png"])) return false;

      // oss上传
      this.ossUpload("signPic", file);

      return false;
    },

    /**
     * oss 上传
     * @param {string} key form字段
     * @param {file} file 上传的文件
     */
    ossUpload(key, file) {
      this.fileLoading[key] = true;

      OSSUpload("register", file).then(res => {
        this.fileLoading[key] = false;

        if (!res) {
          this.$message.error("上传错误，请重新上传");
          this.form[key] = { name: "", uuid: "", formatName: "" };
        } else {
          const { uuid, name, formatName } = res || {};
          this.form[key] = { name, uuid, formatName };
        }

        this.$refs.form.validateField(key);
      });
    },

    // 组装提交数据
    uploadSubmitParam() {
      let param = { ...this.form };
      delete param["isAgree"];

      const formData = new FormData();
      Object.keys(param).forEach(k => {
        if (k === "socialCreditPic" || k === "contractImg" || k === "signPic") {
          formData.append(k, param[k]["formatName"]);
        } else {
          formData.append(k, param[k]);
        }
      });

      return formData;
    },

    test() {
      this.form.companyName = "重庆市敏讯科技有限公司";
      this.form.address = "重庆市北部新区青枫北路30号(拓展区A5栋凤凰C座第5层)";
      this.form.legalPersonName = "龚凯华";
      this.form.legalPersonMobile = "18926418302";
      this.form.legalPersonCertNo = "432522198807105246";
      this.form.socialCreditNo = "91500000MA602XF12T";
      this.form.email = "30254779@qq.com";
      this.form.authPersonName = "龚凯华";
      this.form.authPersonCertNo = "432522198807105246";
      this.form.authPersonBankNo = "6258091693006533";
      this.form.authPersonMobile = "18926418302";
      this.form.bankcode = "308";
      this.form.pwd = "123456";
      this.form.pwdCopy = "123456";
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/pages/account.scss";
</style>
